var utils  = require( './utils' ),
	header = require( './sticky-header' );

var sticky_sidebar = ( function( $ ) {

	var $main,
		$container,
		main_last_height;

	var _init = function() {
		$main            = $( '#main' );
		$container       = $( '#sticky-container' );
		main_last_height = $main.outerHeight();

		if ( utils.viewport_size().width >= 1200 && $( document ).scrollTop() > 0 ) {
			_setup_sticky();
		}

		$( window ).on( 'scroll', function() {
			if ( utils.viewport_size().width >= 1200 && $( document ).scrollTop() > 0 ) {
				_setup_sticky();
			}
		} );

		$( window ).smartresize( function() {
			if ( utils.viewport_size().width >= 1200 && $( document ).scrollTop() > 0 ) {
				_setup_sticky();
			}
		} );
	};

	var _setup_sticky = function() {
		if ( _should_stick() ) {
			_set_container_height();
			$container.find( '.sticky' ).stick_in_parent();
		}
	};

	var _set_container_height = function() {
		var height = $main.outerHeight();
		$container.css( 'height', height );
	};

	var _should_stick = function() {
		var stick = false;

		if ( $main.outerHeight() >= $container.outerHeight() ) {
			stick = true;
		}

		return stick;
	};

	if ( $( '#sticky-container' ).length > 0 ) {
		$( document ).ready( _init );
	}
	
} ) ( jQuery );

module.exports = sticky_sidebar;